const requestUrl = {
  // 地区树
  regionList: '/region',
  // 用户路由
  login: '/login', // 登录
  logOut: '/login/logOut', // 登录
  log: '/log', // 日志
  // 角色管理
  role: '/role',
  // 菜单管理
  menu: '/menu',
  menuFirst: '/menu/first',
  authMenu: '/menu/authMenu', // 拥有的权限菜单
  // 用户管理
  userInfo: '/member/userInfo',
  memberList: '/member/list',
  memberAdd: '/member/add',
  memberEdit: '/member/edit',
  memberDel: '/member/delete',
  editPwd: '/member/editpwd',
  // 保险分类
  cateList: '/cate/list',
  cateAdd: '/cate/add',
  cateEdit: '/cate/edit',
  cateDel: '/cate/delete',
  // 包装
  packing: '/packing',
  // 保险公司
  companyList: '/company/list',
  companyInfoList: '/company/listinfo',
  companyAdd: '/company/add',
  companyEdit: '/company/edit',
  companyDel: '/company',
  compType: '/company/status',
  userRate: '/company/userRate',
  // 费率信息
  rateList: '/rate/list',
  rateAdd: '/rate/author',
  onlyUserAuthComps: '/rate/onlyUserAuthComps', // 单用户批量增加费率
  someUserAuthComps: '/rate/someUserAuthComps', // 多用户批量增加费率
  authCompsOnlyRateUrl: '/rate/authCompsOnlyRate', // 多用户批量增加费率
  // 账户管理
  moneyList: '/money/list', // 财务列表
  exportExcel: '/money/export', // 导出财务列表
  rechargeAdd: '/money/add', // 用户充值
  // 充值管理
  recharge: '/recharge', // 充值记录
  exportRecharge: '/recharge/export', // 充值记录
  // 积分管理
  scoreAdd: '/score',
  // 保单管理
  orderList: '/order/list', // 获取保单
  orderExport: '/order/export', // 导出保单
  addInsure: '/order', // 开始投保
  orderUpload: '/order/upload', // 上传保单
  orderCancel: '/order/cancel', // 注销保单
  orderDel: '/order/delete', // 删除保单
  orderEdit: '/order/edit', // 申请修改
  orderQuit: '/order/signout', // 申请退保
  orderEditVerify: '/order/verify/edit', // 修改审核
  orderQuitVerify: '/order/verify/quit', // 退保待审核
  checkCarRepeat: '/order/check/car', // 判断车牌是否重复
  orderCount: '/order/count', // 保单统计
  cargoList: '/order/cargo', // 对接保险产品
  selfLoad: '/policy/insure', // 自动出单

  // 基础信息管理
  baseData: '/base/list',
  editPublicPwd: '/base/pwd', // 修改通用密码
  editBaseData: '/base/edit', // 修改通用密码
  appList: '/webapp', // app列表
  appAdd: '/webapp/create', // 上传
  appEdit: '/webapp/edit', // 修改
  sms: '/base/sms', // 短信配置
  refreshQrcode: '/base/qrcode', // 刷新二维码
  qrCodeUrl: '/robot/login', // 二维码登录
  robotWxLogin: '/robot/wx_login', // 二维码登录
  robotUsers: '/robot/wx_users', // 微信用户列表
  robotLogout: '/robot/wx_logout', // 退出微信

  // 位置管理
  vLastLocationV3: '/car/vLastLocationV3', // 查询定位
  vHisTrack24: '/car/vHisTrack24', // 查询轨迹
  queryTravelList: '/car/queryLocationRecord', // 定位轨迹列表
  queryTravelInfo: '/car/queryTravelInfo', // 定位轨迹详细信息
  locationByLnglat: '/car/locationBylnglat', // 根据经纬度查询位置

  // 文章管理
  articleGroup: '/article/group/list',
  articleGroupAdd: '/article/group/add', // 添加分类
  articleGroupEdit: '/article/group/edit', // 修改分类
  article: '/article/list',
  articleCustom: '/article/custom', // 定制类型
  articleAdd: '/article/add',
  articleEdit: '/article/edit',

  // 奖品管理
  prizeList: '/prize/list',
  prizeAdd: '/prize/create',
  prizeEdit: '/prize/update',
  prizeDel: '/prize/delete',
  getPrizeSet: '/prize/getSet',
  prizeSet: '/prize/setting',

  prizeRecord: '/prize/prizeRecord', // 中奖记录
  prizeRecordDel: '/prize/prizeRecord', // 中奖记录

  // 签到
  checkinData: '/checkin/list',
  checkinEdit: '/checkin/update',
  checkinList: '/checkin/checkinList',

  // 积分商城
  goodsList: '/goods/list',
  goodsAdd: '/goods/create',
  goodsEdit: '/goods/update',
  goodsDel: '/goods/delete',
  goodsOrderList: '/goods/goodsOrderList',
  goodsOrderDel: '/goods/goodsOrderDel',
  updateStatus: '/goods/updateStatus',

  // 热门产品
  hotGoodsList: '/goods/hotGoodsList',
  createHotGoods: '/goods/createHotGoods',
  updateHotGoods: '/goods/updateHotGoods',
  deleteHotGoods: '/goods/deleteHotGoods',

  // 审核管理
  verifyList: '/verify/verifiedList', // 审核认证列表
  verifiedUpdate: '/verify/verifiedUpdate', // 审核
  verifiedDel: '/verify/verifiedDel', // 删除审核信息

  // 意见反馈
  feedbackList: '/member/feedbackList',
  feedbackUpdate: '/member/feedbackUpdate',
  feedbackDel: '/member/feedbackDel',

  // 公告管理
  notice: '/notice',

  // 聊天
  friends: '/chat/friend', // 好友列表
  chatMessage: '/chat/chatMessage', // 聊天记录信息
  resetChat: '/chat/resetChat', // 清空未读消息
  notReadMessage: '/chat/notReadMessage', // 获取未读消息
  removeChating: '/chat/removeChating', // 移除正在聊天用户

  upload: '/admin/v1/login/upload'

}
export default requestUrl
